import { getFirestore, doc, getDoc } from "firebase/firestore";
import { app } from "../firebase/app";
import { Id } from "../types";

const db = getFirestore(app);
const storeKind = "friends";

export interface Friends {
  friendIds: Id[];
}

export async function fetchFriends(userId: Id): Promise<Friends> {
  const docSnap = await getDoc(doc(db, storeKind, userId));
  return docSnap.exists()
    ? ({ ...docSnap.data() } as Friends)
    : { friendIds: [] };
}
